export const WHOLE_SECTION_COMMENTS_MAX_COUNT = 2;
export const TABLET_VIEWPORT_HEIGHT = 810;
export const HEADER_STICKY_HEIGHT = 155;
export const EN_LANGUAGE = "en-US";
export const ES_LANGUAGE = "es-MX";
